import { ChatBubble } from "./ChatBubble";

export function AssistantOverlay({
  onClose,
  contextLabel,
}: {
  onClose: () => void;
  contextLabel?: string;
}) {
  return (
    <div
      role="dialog"
      className="fixed right-6 bottom-6 w-[390px] max-h-[calc(100vh-60px)] bg-white rounded-2xl shadow-overlay flex flex-col overflow-hidden"
    >
      <div className="bg-ink-900 text-on-dark-bright px-4 py-3 flex items-center gap-3">
        <div className="w-[26px] h-[26px] rounded-md bg-[rgba(233,242,238,0.08)] grid place-items-center">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <path d="M8 1v3M8 12v3M1 8h3M12 8h3M3 3l2 2M11 11l2 2M3 13l2-2M11 5l2-2"
              stroke="#8FD8BC" strokeWidth="1.4" strokeLinecap="round" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[13px] font-semibold">Ask Daybrief</div>
          <div className="text-[10.5px] text-on-dark-faint truncate">
            Context: {contextLabel ?? "current view"}
          </div>
        </div>
        <button aria-label="Close" onClick={onClose}
          className="text-on-dark-faint hover:text-on-dark-bright text-lg">
          ✕
        </button>
      </div>

      <div className="flex-1 bg-bg-chat px-4 py-4 flex flex-col gap-3 overflow-auto">
        <ChatBubble role="ai">
          The assistant isn't connected yet — chat with your reports arrives in an
          upcoming release.
        </ChatBubble>
      </div>

      <div className="border-t border-border-default p-3">
        <div className="flex items-center gap-2 border border-border-default rounded-xl px-3 py-2">
          <input disabled placeholder="Ask about this report…"
            className="flex-1 bg-transparent outline-none text-[13px] placeholder:text-text-faint" />
          <button disabled aria-label="Send"
            className="w-7 h-7 rounded-md bg-ink-900 text-on-dark-bright grid place-items-center opacity-60">
            →
          </button>
        </div>
      </div>
    </div>
  );
}
